import { Lookup } from '../lookup.interface';
export const ActionPlanObjectives: { [name: string]: Lookup } = {
  financial: { displayValue: 'Financial' },
  employment: { displayValue: 'Employment' },
  career: { displayValue: 'Career' },
  training: { displayValue: 'Training' },
};
